import { render, staticRenderFns } from "./FeatureFlagsCard.vue?vue&type=template&id=51bd189a&scoped=true"
import script from "./FeatureFlagsCard.vue?vue&type=script&lang=js"
export * from "./FeatureFlagsCard.vue?vue&type=script&lang=js"
import style0 from "./FeatureFlagsCard.vue?vue&type=style&index=0&id=51bd189a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bd189a",
  null
  
)

export default component.exports